//-- React Standard
import React, { Component } from "react";
import { connect } from 'react-redux';
import config from '../../config';

//-- Custom
import TopBar from "../Common/TopBar/TopBar";
import SideBar from "../Common/SideBar/SideBar";
import Footer from "../Common/Footer/Footer";
import { apiConstants } from '../../_constants/api.constants';
import Pagination from "../Common/Pagination/Pagination";
import PageLimit from "../Common/PageLimit/PageLimit";
import DeletePopup from "../Common/Popup/DeletePopup";
import AddEditNotifications from "./AddEditNotifications";
import { notificationActions } from "../../_actions";

class Notifications extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sort: {
                sortKey: null,
                direction: 'desc',
            },
            totalPage: '',
            totalDataCount: '',
            currentPage: 1,
            getNotificationsList: [],
            viewOpen: false,
            editOpen: false,
            deleteOpen: false,
            notifications: {
                title: '',
                advertisment_image: '',
            },
            popupType: '',
            addButton: false,
        };
    }

    /*
    * componentDidMount - Initially it will call and get the notifications data
    */
    componentDidMount() {
        const { dispatch } = this.props;
        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = config.perPageData;
        postData.notification_type = "bell";

        dispatch(notificationActions.getNotificationsList(apiConstants.GET_NOTICATIONS, postData));
    }

    /*
    * componentWillReceiveProps - Whenever Props change, it will call and store data
    * update the state values with new props values, this method will get called whenever any change happens to props values
    */
    componentWillReceiveProps(props) {
        if (props.getNotificationsList) {
            if (props.getNotificationsList.getNotificationsList) {
                if (props.getNotificationsList.getNotificationsList.data.data) {
                    this.setState({
                        totalPage: props.getNotificationsList.getNotificationsList.data.data.totalPages,
                        totalDataCount: props.getNotificationsList.getNotificationsList.data.data.totalCount,
                        getNotificationsList: props.getNotificationsList.getNotificationsList.data.data,
                    })
                }
            }
        }
    }

    /*
    *   Pagination function: It will call from pagination section and change data in table
    */
    makeHttpRequestWithPage = (pageNumber) => {
        const { dispatch } = this.props;
        this.setState({
            currentPage: pageNumber
        });

        let postData = {};
        postData.page = pageNumber;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = config.perPageData;
        postData.notification_type = "bell";

        dispatch(notificationActions.getNotificationsList(apiConstants.GET_NOTICATIONS, postData));
    }

    // get notifications list based on changed per page limit
    // changeTableData = (e) => {
    //     const { dispatch } = this.props;

    //     let postData = {};
    //     postData.page = 1;
    //     postData.orderBy = "id";
    //     postData.orderByAscDesc = "ASC";
    //     postData.perPage = parseInt(e.target.value);

    //     dispatch(notificationActions.getNotificationsList(apiConstants.GET_NOTICATIONS, postData));
    // }

    /*
    * searchNotifications - User can search data from the database and it will appear
    */
    // searchNotifications(keyword) {
    //     const { dispatch } = this.props;
    //     let postData = {};
    //     postData.page = 1;
    //     postData.orderBy = "id";
    //     postData.orderByAscDesc = "ASC";
    //     postData.perPage = 10;

    //     if (keyword.target.value !== '') {
    //         postData.qwery = keyword.target.value;
    //         dispatch(notificationActions.getNotificationsList(apiConstants.SEARCH_NOTICATIONS, postData));
    //     } else {
    //         dispatch(notificationActions.getNotificationsList(apiConstants.GET_NOTICATIONS, postData));
    //     }



    // }

    //-- Popup Handler
    /*
    *   Modal open-close functionality
    */
    popupOpen = (notifications, type, btnClick) => {
        //-- check add button clicked
        if (btnClick === 'addButton') {
            this.setState({ addButton: true });
            this.setState({ popupType: 'AddNotification' })
        }
        this.setState({ notifications, [type]: true })
    };

    EditPopupOpen = (notificationData, type) => {
        this.setState({
            data: notificationData,
            popupType: 'EditNotification',
            addButton: true
        });

        this.setState({ [type]: true })
    }


    DeletePopupOpen = (notificationId, type) => {
        this.setState({
            deleteId: notificationId
        });

        this.setState({ [type]: true })
    }
    /*
    *   Close the popup
    */
    popupClose = (type) => {
        this.setState({
            notifications: {
                title: '',
                type: '',
                advertisment_image: '',
            },
            addButton: false,
            [type]: false
        });
    };

    // /*
    // *   We are handling validation from this function
    // */
    // handleValidation(data) {
    //     const { siteConstants } = this.props.language;

    //     let fields = data.defaultData;
    //     let errors = {};
    //     let formIsValid = true;
    //     //Name
    //     if ((fields["title"] == '')) {
    //         formIsValid = false;
    //         if (fields["title"] == '') {
    //             errors["title"] = siteConstants.ERR_CAN_NOT_BLANK;
    //         }
    //     }

    //     if (!fields["title"]) {
    //         if (!fields["title"].match(/^[a-zA-Z]+$/)) {
    //             formIsValid = false;
    //             errors["title"] = siteConstants.ERR_ONLY_LETTERS;
    //         }
    //     }
    //     return ({ errors, formIsValid });
    // }

    /* 
        we can remove the selected data, using the below function 
    */
    deleteNotifications = (notificationId) => {
        let postData = {};
        postData.page = this.state.currentPage;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = config.perPageData;
        postData.notification_type = "bell";

        let obj = {};
        obj.id = notificationId;
        this.props.dispatch(notificationActions.deleteNotifications(apiConstants.DELETE_NOTIFICATIONS, obj, apiConstants.GET_NOTICATIONS, postData));
        this.popupClose('deleteOpen');
    }

    /*
    *   sendNotifications
    */
    sendNotifications = (id) => {
        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = config.perPageData;
        postData.notification_type = "bell";

        let obj = {};
        obj.id = id;
        this.props.dispatch(notificationActions.sendNotifications(apiConstants.SEND_BELL_NOTIFICATIONS, obj, apiConstants.GET_NOTICATIONS, postData));

    }

    //-- Main function
    render() {
        const { siteConstants } = this.props.language;
        return (
            <div id="wrapper">
                <SideBar />

                <div id="content-wrapper" className="d-flex flex-column">
                    {/* <!-- Main Content --> */}
                    <div id="content">

                        <TopBar />
                        <nav className="" aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href="/dashboard">{siteConstants.GEN_DASHBOARD}</a>
                                </li>
                                <li className="active breadcrumb-item" aria-current="page">
                                    {siteConstants.MENU_NOTIFICATIONS}
                                </li>
                            </ol>
                        </nav>

                        {/* <!-- Begin Page Content --> */}
                        <div className="container-fluid">

                            <div className="d-sm-flex align-items-center justify-content-between mb-4 mt-2">
                                <h1 className="h3 mb-0 text-gray-800">{siteConstants.MENU_NOTIFICATIONS}</h1>
                                <a href="javascript:void(0)" onClick={() => this.popupOpen(this.state.notifications, 'editOpen', 'addButton')}>
                                    <span className="text">
                                        <button className="btn btn-primary">{siteConstants.BTN_ADD}</button>
                                    </span>
                                </a>
                            </div>


                            <div className="card shadow mb-4">
                                <div className="card-body">
                                    {/* style={{"overflowY": "scroll"}} */}
                                    <div className="table-responsive" >
                                        <div className="row">
                                            {/* Page limit drop down */}
                                            {/* <PageLimit changeLimit={(e) => this.changeTableData(e)} />

                                            <div className="col-sm-12 col-md-6">
                                                <div id="dataTable_filter" className="dataTables_filter">
                                                    <label>
                                                        <input type="search" palaceholder={siteConstants.GEN_SEARCH} className="form-control form-control-sm" placeholder="" aria-controls="dataTable" onChange={(e) => this.searchNotifications(e)} />
                                                    </label>
                                                </div>
                                            </div> */}
                                        </div>
                                        <table className="table table-bordered" width="100%" cellSpacing="0">
                                            <thead>
                                                <tr>
                                                    <th scope="col" width="5%">{siteConstants.GEN_NUMBER}</th>
                                                    <th scope="col" width="20%">{siteConstants.GEN_TITLE}</th>
                                                    <th scope="col">{siteConstants.GEN_MESSAGE}</th>
                                                    <th scope="col" width="18%">{siteConstants.GEN_MESSAGE_FOR}</th>
                                                    <th width="5%">{siteConstants.GEN_SENT}</th>
                                                    <th width="5%">{siteConstants.LABEL_ACTION}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.getNotificationsList != undefined && this.state.getNotificationsList.length > 0 ? this.state.getNotificationsList.map((notifications, index) => {
                                                        let d = new Date(notifications.expiry);
                                                        let expiryDate = d.toLocaleDateString();
                                                        return (
                                                            <tr key={index}>
                                                                <td scope="row">{index + 1}</td>
                                                                <td>{notifications.title}</td>
                                                                <td>{notifications.notification_message}</td>
                                                                <td>{notifications.notification_for}</td>
                                                                <td>
                                                                    <a className="actionIcon" title="bell" href="javascript:void(0)" onClick={() => this.sendNotifications(notifications._id)}><span><img src="assets/img/svg/motification-icon.svg" alt="Bell" /></span></a>
                                                                </td>
                                                                <td className="tdTextCenter">
                                                                    <a className="actionIcon" title="Delete" href="javascript:void(0)" onClick={() => this.DeletePopupOpen(notifications._id, 'deleteOpen', 'deleteClick')}><span><img src="assets/img/svg/Bin.png" alt="Delete" /></span></a>
                                                                </td>
                                                            </tr>
                                                        )
                                                    }) : <tr>
                                                            <td colSpan="6" className="noRecordFound">{siteConstants.GEN_NO_RECORD}</td>
                                                        </tr>
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                    {/* calling the another componenet */}
                                    <Pagination totalPage={this.state.totalPage} currentPage={this.state.currentPage} funPagination={this.makeHttpRequestWithPage} />



                                </div>
                            </div>

                        </div>
                        {/* <!-- /.container-fluid --> */}

                    </div>
                    {/* <!-- End of Main Content --> */}

                    <Footer />
                </div>

                {/* Start Popup -Edit notifications details  */}
                <AddEditNotifications
                    popupType={this.state.popupType}
                    userData={this.state.data}
                    currentPage={this.state.currentPage}
                    addButton={this.state.addButton}
                    editOpen={this.state.editOpen}
                    funPopupClose={this.popupClose}
                    funNotificationsAddUpdate={(e, data) => this.notificationsAddUpdate(e, data)}
                    defaultData={this.state.notifications}
                />
                {/* End Popup -Edit notifications details  */}
                {/* Delete popup */}
                <DeletePopup deleteOpen={this.state.deleteOpen} deleteId={this.state.deleteId} funPopupClose={this.popupClose} funDelete={this.deleteNotifications} />
            </div>
        );
    }
}


//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
    const { getNotificationsList, language } = state;
    return {
        getNotificationsList,
        language
    };
}

const connectedNotifications = connect(mapStateToProps)(Notifications);
export { connectedNotifications as Notifications };